<template>
  <div class="content">
    <!-- <div class="bg">
      <div v-if="!iscn" class="text-bg text-bg-en">
        <p class="line1">We believe</p>
        <p class="line2">
          our consumption behaviours can <br />
          reshape the manufacturing industry. Through this, we can all exert an impact on climate
          change.
        </p>
      </div>
    </div> -->
    <div class="bg-content">
      <div v-if="iscn" class="bg-text">
        <p>和转转一起，拯救世界吧！</p>
      </div>
      <div v-if="!iscn" class="bg-text bg-text-en">
        <p>So next, our GOALS are</p>
      </div>
      <!-- <div v-if="iscn" class="text2">
        <p>转转致力于打造一个专业、便捷的二手交易平台。</p>
        <p>我们相信，那些功能全、质量好的</p>
        <p>二手物品，不应该被闲置或丢弃,</p>
        <p>而是通过我们的流转，继续发光发热，</p>
        <p>充分发挥它们的全部价值！</p>
        <p>购买二手商品循环使用，是我们人人都能参与的绿色消费方式。</p>
        <p>在省钱的同时，我们还为可持续世界贡献了一份力量！</p>
      </div>
      <div v-if="!iscn" class="text2 text2-en">
        <p>
          Zhuanzhuan creates a platform empowering<br />
          secondhand transactions,<br />
          which directly helps extend the life cycle of fully-functional<br />
          items that would otherwise be replaced and thrown away.<br />
          By recycling and purchasing secondhand products,<br />
          we not only save money<br />
          but contribute to a more sustainable world.<br />
          And it is a simple action that<br />
          everyone can take.
        </p>
      </div> -->
      <!-- <div class="person"></div> -->
    </div>
    <div v-if="iscn" class="people people-fast">
      <p class="line1">让更多人加入绿色循环</p>
      <p class="line2">生活总要有点绿！</p>
      <p class="line2">二手循环是人人都可以参与的，</p>
      <p class="line2">并可以从点滴开始做起的绿色行动。</p>
      <p class="line2">我们努力让更多人快乐、积极地参与到绿色循环当中，</p>
      <p class="line2">一起创造一个更可持续的绿色世界！</p>
      <img @click="goJoin('cn')" src="../assets/detail-btn.png" alt="" class="detail-btn">
      <p class="line4">成为循环可持续企业榜样</p>
      <p class="line5">改变从自身开始！</p>
      <p class="line5">我们也将以身作则，让绿色循环成为我们的日常。</p>
      <p class="line5">同时，我们也希望作为循环经济的引领者，</p>
      <p class="line5">带领更多伙伴让世界因流转更可持续！</p>
      <img @click="goModel('cn')" src="../assets/detail-btn.png" alt="" class="detail-btn">
    </div>
    <div v-if="!iscn" class="people people-en people-fast">
      <p class="line1">
        Encouraging more people to join<br />
        the green circular economy<br />
      </p>
      <p class="line2">
        Life needs a touch of green!<br />
        Recycling and purchasing second-hand products is a simple green action that everyone can take.<br />
        We strive to galvanize more people to join the green circulation with joy and enthusiasm.<br />
        Together, we can create a more sustainable and greener world!
      </p>
      <img @click="goJoin('en')" src="../assets/detail-btn-en.png" alt="" class="detail-btn detail-btn-en">
      <p class="line3">
        Becoming a role model for circular <br />
        and sustainable business practices
      </p>
      <p class="line5">
        Change starts with ourselves!<br />
        We are committed to leading by example, integrating sustainability into<br />
        every aspects of our own operations.<br />
        As a pioneer of the circular economy, we also aspire to inspire more partners<br />
        to join us in making the world more sustainable!
      </p>
      <img @click="goModel('en')" src="../assets/detail-btn-en.png" alt="" class="detail-btn detail-btn-en">
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Rellax from 'rellax'

export default Vue.extend({
  name: 'green-area',
  computed: {
    iscn: function() {
      return this.$store.state.lang === 'zh-cn'
    }
  },
  mounted() {
    new Rellax('.bg-text', {
      speed: 1,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
    new Rellax('.people', {
      speed: 1,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
    // new Rellax('.detail-btn', {
    //   speed: 0.4,
    //   center: true,
    //   wrapper: null,
    //   round: true,
    //   vertical: true,
    //   horizontal: false
    // })
  },
  methods: {
    goJoin(lang) {
      console.log(lang, location.pathname)
      window.open(`${location.origin}${location.pathname}?lang=${lang}#/intro-join`)
      // this.$router.push({
      //   path: '/intro-join'
      //   // query: { lang }
      // })
      // if (lang == 'cn') {
      //   this.$router.push({
      //     path: '/intro-join',
      //     query: { lang: 'cn' }
      //   })
      // } else {
      //   this.$router.push('/intro-join')
      // }
    },
    goModel(lang) {
      window.open(`${location.origin}${location.pathname}?lang=${lang}#/intro-model`)
      // window.open(`https://www.zhuanzhuan.com/sustainability/?lang=${lang}#/intro-model`)
      // this.$router.push({
      //   path: '/intro-model'
      //   // query: { lang }
      // })
      // if (lang == 'cn') {
      //   this.$router.push('/join')
      // } else {
      //   this.$router.push('/join')
      // }
    }
  }
})
</script>

<style scoped lang="scss">
.content {
  position: relative;
  width: 1920px;
  min-width: 1280px;
  max-width: 1920px;
  height: 2425px;
  margin: 0 auto;
  background: #fff;
}

// .bg {
//   position: relative;
//   width: 100%;
//   height: 1879px;
//   background: url('../assets/green-bg.png') no-repeat 0 0/ 100% 100%;
//   .text-bg {
//     position: absolute;
//     top: 210px;
//     left: 50%;
//     width: 575px;
//     height: 266px;
//     margin-left: -287px;
//     text-align: center;
//     background: url('../assets/green-5.png') no-repeat 0 0/ 100% 100%;
//   }
//   .line1 {
//     margin-top: 60px;
//     margin-bottom: 30px;
//     color: #fff;
//     font-size: 72px;
//     font-family: alibaba;
//     line-height: 50px;
//   }
//   .line2 {
//     color: #fff;
//     font-size: 24px;
//     word-break: keep-all;
//   }
//   .text-bg-en {
//     position: absolute;
//     top: 110px;
//     left: 50%;
//     width: 575px;
//     height: 359px;
//     margin-left: -287px;
//     text-align: center;
//     background: url('../assets/green-5-en.png') no-repeat 0 0/ 100% 100%;
//     .line1 {
//       margin-top: 90px;
//       margin-bottom: 30px;
//       color: #fff;
//       font-size: 80px;
//       font-family: alibaba;
//       line-height: 40px;
//     }
//     .line2 {
//       padding: 0 70px;
//       color: #fff;
//       font-size: 28px;
//       font-size: 24px;
//       font-family: alibaba3;
//     }
//   }
// }

.bg-content {
  position: relative;
  width: 100%;
  height: 1879px;
  margin-top: -144px;
  // background: #399f67;
  background: url('../assets/green-bg.png') no-repeat center center;
  background-size: 1920px 1879px;
  .bg-text {
    position: absolute;
    top: 888px;
    left: 50%;
    width: 1223px;
    height: 189px;
    margin-left: -611px;
    background: url('../assets/green-7.png') no-repeat 0 0/ 100% 100%;
    p {
      width: 100%;
      margin-top: 54px;
      color: #fff;
      font-size: 80px;
      font-family: alibaba;
      line-height: 80px;
      text-align: center;
    }
  }

  .bg-text-en {
    position: absolute;
    // top: 200px;
    // left: 50%;
    // width: 1223px;
    // height: 225px;
    // margin-left: -611px;
    background: url('../assets/green-7-en.png') no-repeat 0 0/ 100% 100%;
    p {
      width: 100%;
      // margin-top: 35px;
      color: #fff;
      font-size: 68px;
      font-family: alibaba;
      line-height: 80px;
      text-align: center;
    }
  }
  // .text2 {
  //   position: absolute;
  //   top: 535px;
  //   width: 100%;
  //   color: #000;
  //   font-size: 20px;
  //   line-height: 36px;
  //   text-align: center;
  // }

  // .person {
  //   position: absolute;
  //   top: 513px;
  //   left: 1260px;
  //   width: 407px;
  //   height: 432px;
  //   background: url('../assets/green-9.png') no-repeat 0 0/ 100% 100%;
  // }
}

.people {
  position: absolute;
  top: 1174px;
  left: 50%;
  width: 1418px;
  height: 1251px;
  margin-left: -709px;
  text-align: center;
  background: url('../assets/gray-bg.png') no-repeat 0 0/ 100% 100%;
  .line1 {
    margin-top: 91px;
    margin-bottom: 32px;
    color: #111;
    font-size: 56px;
    font-family: alibaba;
    line-height: 68px;
  }
  .line2,
  .line5 {
    color: #000;
    font-size: 20px;
    line-height: 36px;
  }
  .line3 {
    margin-top: 207px;
    color: #111;
    font-size: 56px;
    font-family: alibaba;
    line-height: 68px;
  }
  .line4 {
    margin-top: 192px;
    margin-bottom: 32px;
    font-size: 56px;
    font-family: alibaba;
    line-height: 68px;
  }
}

.people-en {
  .line1 {
    margin-top: 73px;
    margin-bottom: 32px;
    color: #111;
    font-size: 52px;
    font-family: alibaba;
    line-height: 64px;
  }
  .line2,
  .line5 {
    color: #000;
    font-size: 20px;
    font-family: alibaba3;
    line-height: 36px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
  }
  .line3 {
    margin-top: 142px;
    margin-bottom: 32px;
    color: #111;
    font-size: 52px;
    font-family: alibaba;
    line-height: 64px;
  }
}
.detail-btn {
  width: 251px;
  height: 95px;
  margin-top: 55px;
  cursor: pointer;
  &.detail-btn-en {
    margin-top: 55px;
  }
}
</style>
